document.addEventListener('DOMContentLoaded', () => {
  const sliders = () => {
    if (window.innerWidth < 992) {
      const followUsSlider = new CustomSimpleSlider('.container.follow-us-cards-container', '.follow-us-contact__cards', '.follow-us-contact__item');
      const articleSlider = new CustomSimpleSlider('.articles-list-container', '.articles-list', '.articles-list .card');
      const productPhilosophySlider = new CustomSimpleSlider('.learn-more-card__cards-container', '.learn-more-card__cards', '.learn-more-card__card');
    }
  };


  sliders()
});